module.exports = __webpack_public_path__ + "static/media/quetion.baf5a361.png";